import React, { useId } from 'react';

interface AmkMarkProps {
  size?: number;
  className?: string;
}

// "A" monogram with a rising chart crossbar breaking out as an arrow
export const AmkMark: React.FC<AmkMarkProps> = ({ size = 32, className }) => {
  const gradId = `amk-gold-${useId().replace(/:/g, '')}`;
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className} aria-hidden="true">
      <defs>
        <linearGradient id={gradId} x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#8a6a24" />
          <stop offset=".45" stopColor="#d4a237" />
          <stop offset=".75" stopColor="#f6d77a" />
          <stop offset="1" stopColor="#c9952e" />
        </linearGradient>
      </defs>
      <path d="M10 88 L43 12 L57 12 L90 88 L76 88 L50 29 L24 88 Z" fill={`url(#${gradId})`} />
      <path d="M27 73 L44 58 L54 66 L78 42" stroke="#07070b" strokeWidth="12" strokeLinejoin="miter" />
      <path d="M27 73 L44 58 L54 66 L78 42" stroke={`url(#${gradId})`} strokeWidth="6" strokeLinejoin="miter" />
      <path d="M91 29 L86.5 50.2 L69.8 33.5 Z" fill="#f6d77a" />
    </svg>
  );
};

interface AmkLogoProps {
  size?: number;
  className?: string;
}

// Mark + "AMK VENTURES" wordmark lockup
const AmkLogo: React.FC<AmkLogoProps> = ({ size = 32, className }) => (
  <span className={`amk-logo ${className || ''}`} aria-label="AMK Ventures">
    <AmkMark size={size} />
    <span className="amk-logo-word" style={{ fontSize: size * 0.5 }}>
      <span className="amk-logo-amk">AMK</span>
      <span className="amk-logo-ventures">Ventures</span>
    </span>
  </span>
);

export default AmkLogo;
